import { useReducer } from 'react';
import { formReducer } from './formReducer';
import {FormContext} from './formContext'


const FormState = ({ children }: any) => {

    const initialState = {
    };

    const [state, dispatch] = useReducer(formReducer, initialState);
  
    return (
      <FormContext.Provider value={{state, dispatch}}>
        {children}
      </FormContext.Provider>
    );
  };
  
  export default FormState;